export default __webpack_public_path__ + "resources/icons/n322-00a9.png";